export default {
    addKeep(state, name) {
        if (name && state.state.keepAlive.indexOf(name) == -1) {
            state.state.keepAlive.push(name);
        }
    },
    minusKeep(state, name) {
        if (name && state.state.keepAlive.indexOf(name) != -1) {
            state.state.keepAlive.splice(state.state.keepAlive.indexOf(name), 1)
        }
    },
    uploadUserinfo(state, info) {
        state.state.userinfo = info ? JSON.parse(info) : {};
    },
    setQuestion(state, question) {
        state.state.question = question ? JSON.parse(question) : [];
    },
    uploadReportList(state, reportList) {
        state.state.reportList = reportList ? reportList : [];
    },
    uploadTeacherType(state, list) {
        state.state.teacherType = list ? list : [];
    },
    uploadBaseType(state, list) {
      state.state.baseTypeList = list ? list : [];
  },
}